module.exports = __webpack_public_path__ + "static/img/banner_pc.4f2378b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/module/active_423/images/banner_pc.jpg
// module id = Rg5t
// module chunks = 92